import storage from 'libs/storage'
import api from '@/api'
export default {
    state: {
        userInfo: '',
        infoMiss:false
    },
    getters: {
        getUserInfo: state => {
            return state.userInfo;
        }
    },
    mutations: {
        setUserInfo(state, userInfo) {
            storage.set('userInfo', userInfo);
            state.userInfo = userInfo
        },
        clearUserInfo(state){
            storage.remove('userInfo')
            state.userInfo=''
        }
    },
    actions: {
         getUserInfo({ commit}) {
            return   new Promise((resolve, reject) => {
                try {
                    //直接用本地缓存 不请求数据
                    storage.get('userInfo').then((res)=>{
                        if(res){
                            let {urid,token} = res;
                            api.user.getUserInfo({urid,token}).then((res)=>{
                                let {data} = res;
                                Object.assign(data,{urid,token});
                                if(res.status*1===200){
                                    commit('setUserInfo',data)
                                    resolve(data);
                                }else{
                                    resolve(data)
                                }
                            })
                        }else{
                            reject();
                        }
                    })

                } catch (error) {
                    reject(error);
                }
            });
        }
    }
}
